import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-shape/src/order/reverse.js
// module id = ../../../../d3-shape/src/order/reverse.js
// module chunks = 3